<template>
  <div class="search-by-criteria">
    <div v-for="(block, index) in searchBlocks" :key="index">
      <search-block ref="searchBlock" :is-removable="index > 0" @remove-search-block="() => removeSearchBlock(index)" />
      <el-divider v-if="index < searchBlocks.length - 1">or</el-divider>
    </div>

    <div class="search-by-criteria__buttons">
      <el-button v-if="multiblock" type="primary" icon="el-icon-plus" @click="addSearchBlock">
        Add form
      </el-button>
      <el-button type="primary" @click="handleSearchParticipants" :disabled="isButtonDisabled('search-participants')">
        Search
      </el-button>
    </div>
  </div>
</template>

<script>
import SearchBlock from '@/components/searchEventParticipants/SearchBlock.vue';

import { parseErrorsByFields, removeArrayElementById } from '@/utils/index.js';
import { searchParticipant } from '@/api/events.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'SearchByCriteria',
  props: {
    skip: {
      type: Number,
      required: false,
    },
    limit: {
      type: Number,
      required: false,
    },
    eventId: {
      type: Number,
      required: false,
    },
    multiblock: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mixins: [disableButton],
  components: {
    SearchBlock,
  },
  data() {
    return {
      searchBlocks: [],
    };
  },
  computed: {},
  methods: {
    showMessage,
    parseErrorsByFields,
    removeArrayElementById,
    async fetchParticipants(formData) {
      this.disableButton('search-participants');
      const { errors, success, data } = await searchParticipant(formData);
      this.enableButton('search-participants');

      if (success) {
        this.$emit('recieve-data', data);
      }
    },
    handleSearchParticipants() {
      const { skip, limit, eventId } = this;

      const formData = {
        skip,
        limit,
        filterModel: {
          eventId,
          searchBlocks: [],
        },
      };

      if (this.$refs.searchBlock) {
        this.$refs.searchBlock.forEach((block) =>
          formData.filterModel.searchBlocks.push(block.getSearchBlockData()),
        );
      }

      this.fetchParticipants(formData);
    },
    addSearchBlock() {
      this.searchBlocks.push({});
    },
    removeSearchBlock(index) {
      this.searchBlocks = this.removeArrayElementById(this.searchBlocks, index);
    },
    updateSearchData() {
      this.handleSearchParticipants();
    },
  },
  created() {
    this.addSearchBlock();
  },
};
</script>

<style lang="scss">
.search-by-criteria {
  &__buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--global-dimension-size-675);
  }

  .el-divider {
    &--horizontal {
      margin: var(--global-dimension-size-500) 0;
    }

    &__text {
      background-color: var(--color-gray-100);
    }
  }
}
</style>
